/* eslint-disable import/first */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CustomCancelButton } from "./styles";
export function CancelButton(_a) {
    var text = _a.text, props = __rest(_a, ["text"]);
    return (_jsx(CustomCancelButton, __assign({ variant: "outlined", sx: {
            color: "#EB6C61",
            height: "45px",
            padding: "0px 25px",
            textTransform: "uppercase",
        } }, props, { children: text })));
}
export function CloseButton(_a) {
    var text = _a.text, props = __rest(_a, ["text"]);
    return (_jsx(CustomCancelButton, __assign({ variant: "outlined", sx: {
            color: "#EB6C61",
            height: "40px",
            padding: "0px 10px",
            textTransform: "capitalize",
            borderRadius: "5px !important",
        } }, props, { children: text })));
}
export function CleanButton(_a) {
    var text = _a.text, props = __rest(_a, ["text"]);
    return (_jsx(CustomCancelButton, __assign({ variant: "outlined", sx: {
            color: "#EB6C61",
            height: "40px",
            padding: "0px 25px",
            textTransform: "capitalize",
        } }, props, { children: text })));
}
